import { useTranslation } from "react-i18next";

import { hasValue } from "../../../../../Helpers/validations/common";
import {
  displayDate,
  displayDateTime,
  parseDateFromUtc,
} from "../../../../../Helpers/utils/utils";

function LogisticsPackageExtra(logisticsPackage) {
  const [t] = useTranslation();

  function getLogisticsInfo() {
    const logisticsInfo = [
      { key: t("LogisticId"), value: logisticsPackage.logisticId },
      { key: t("Status"), value: logisticsPackage.inbound.status },
      {
        key: t("ReceiptDate"),
        value: hasValue(logisticsPackage.receiptDate)
          ? displayDate(new Date(logisticsPackage.receiptDate).toString())
          : "",
      },
      {
        key: t("VendorShipmentNo"),
        value: logisticsPackage.vendorShipmentNo,
      },
      {
        key: t("Reference"),
        value: logisticsPackage.inbound.refId,
      },
      { key: t("SupplierRef"), value: logisticsPackage.inbound.supplierRef },
      { key: t("Name"), value: logisticsPackage.inbound.senderName },
      { key: t("Email"), value: logisticsPackage.inbound.senderEmail },
      {
        key: t("PhoneNumber"),
        value: logisticsPackage.inbound.senderPhonenumber,
      },
      { key: t("City"), value: logisticsPackage.inbound.senderCity },
      {
        key: t("AddressLine1"),
        value: logisticsPackage.inbound.senderAddressLine1,
      },
      {
        key: t("AddressLine2"),
        value: logisticsPackage.inbound.senderAddressLine2,
      },
      { key: t("PostalCode"), value: logisticsPackage.inbound.senderPostCode },
      {
        key: t("CountryCode"),
        value: logisticsPackage.inbound.senderCountryCode,
      },
      { key: t("Type"), value: logisticsPackage.inbound.type },
      {
        key: t("ExpectedReceiveDate"),
        value: logisticsPackage.inbound.expectedReceiveDate,
      },
    ];

    return logisticsInfo;
  }

  function getBarcodeInfo() {
    const barcodeInfo = [
      { key: t("Barcode"), value: logisticsPackage.barcode?.barcode },
      {
        key: t("SchoolScanCompleteDate"),
        value: displayDateTime(
          parseDateFromUtc(logisticsPackage.barcode?.schoolScanCompleteDate)
        ),
      },
      {
        key: t("SchoolNumber"),
        value: logisticsPackage.barcode?.student?.schoolNumber,
      },
      {
        key: t("School"),
        value: logisticsPackage.barcode?.student?.schoolName,
      },
      {
        key: t("Student"),
        value: `${logisticsPackage.barcode?.student?.firstName} ${logisticsPackage.barcode?.student?.preposition} ${logisticsPackage.barcode?.student?.lastName}`,
      },
      { key: t("Email"), value: logisticsPackage.barcode?.student?.email },
      {
        key: t("AddressLine1"),
        value: logisticsPackage.barcode?.student?.adress,
      },
      { key: t("City"), value: logisticsPackage.barcode?.student?.city },
      {
        key: t("PostalCode"),
        value: logisticsPackage.barcode?.student?.postalCode,
      },
      {
        key: t("Country"),
        value: logisticsPackage.barcode?.student?.country,
      },
      {
        key: t("ScanUser"),
        value: logisticsPackage.barcode?.schoolScanUser,
      },
    ];

    return barcodeInfo;
  }

  function getBarcodeReturnsInfo() {
    const returnsInfo = [
      {
        key: t("Uid"),
        value: logisticsPackage.barcodeReturn?.uid,
      },
      {
        key: t("schoolUid"),
        value: logisticsPackage.barcodeReturn?.schoolUid,
      },
      {
        key: t("customerUid"),
        value: logisticsPackage.barcodeReturn?.customerUid,
      },
      {
        key: t("createdAt"),
        value: displayDateTime(
          parseDateFromUtc(logisticsPackage.barcodeReturn?.createdAt)
        ),
      },
      {
        key: t("updatedAt"),
        value: displayDateTime(
          parseDateFromUtc(logisticsPackage.barcodeReturn?.createdAt)
        ),
      }
    ];

    return returnsInfo;
  }

  return { getLogisticsInfo, getBarcodeInfo, getBarcodeReturnsInfo };
}

export const initSenderInfo = {
  expectedReceiveDate: "",
  refId: "",
  senderAddressLine1: "",
  senderAddressLine2: "",
  senderCity: "",
  senderCountryCode: "",
  senderEmail: "",
  senderName: "",
  senderPhonenumber: "",
  senderPostCode: "",
  status: "",
  supplierRef: "",
  type: "",
};

export const initLogisticsPackage = {
  barcode: {
    barcode: "",
    barcodeBooks: [],
    classNumber: "",
    completeDate: "",
    id: "",
    isCompleted: false,
    schoolScanComplete: false,
    schoolScanCompleteDate: "",
    schoolScanUser: "",
    student: "",
    userId: "",
    year: "",
  },
  id: "",
  inbound: initSenderInfo,
  lines: [],
  logisticId: "",
  receiptDate: "",
  vendorShipmentNo: "",
};

export const initLine = {
  quantity: 0,
  defective: false,
  sku: "",
  inboundRef: "",
  inboundLineRef: "",
  barcodeBook: "",
};

export default LogisticsPackageExtra;
